import { Component, Input } from '@angular/core'

@Component({
  standalone: false,
  selector: 'se-menu-reference',
  templateUrl: './menu-reference.component.html',
  
})
export class SeMenuReferenceComponent {
  @Input('se-data-reference-id') referenceId: string
}
